import { ProveedorRoutingModule } from './proveedor-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccesoProveedorComponent } from './pages/acceso-proveedor/acceso-proveedor.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ProveedorComponent } from './proveedor.component';
import { HomeProveedorComponent } from './pages/home-proveedor/home-proveedor.component';

@NgModule({
  declarations: [ProveedorComponent, AccesoProveedorComponent, HomeProveedorComponent],
  imports: [
    CommonModule,
    SharedModule,
    ProveedorRoutingModule
  ]
})
export class ProveedorModule { }
